import { useMutation } from "convex/react"
import { api } from "../../convex/_generated/api"
import type { Id } from "../../convex/_generated/dataModel"
import { Button } from "@/components/ui/button"
import { usePendingAction } from "@/hooks/use-pending-action"

type AdminCompanyActionsProps = {
  companyId: Id<"companies">
  verificationStatus: "pending" | "approved" | "rejected"
  size?: "sm" | "default"
}

export function AdminCompanyActions({
  companyId,
  verificationStatus,
  size = "sm",
}: AdminCompanyActionsProps) {
  const setVerification = useMutation(api.admin.setVerification)
  const { pending, run } = usePendingAction()

  const decide = (status: "approved" | "rejected") =>
    run(() => setVerification({ companyId, status }), {
      success: status === "approved" ? "Company approved" : "Company rejected",
    })

  return (
    <div className="flex flex-wrap gap-2">
      {verificationStatus !== "approved" && (
        <Button size={size} disabled={pending} onClick={() => void decide("approved")}>
          Approve
        </Button>
      )}
      {verificationStatus !== "rejected" && (
        <Button
          size={size}
          variant="outline"
          disabled={pending}
          onClick={() => void decide("rejected")}
        >
          Reject
        </Button>
      )}
    </div>
  )
}
